// Assets/custom-variant-gallery.js
(function () {

  const norm = (s) => (s || "").toString().trim().toLowerCase();

  function getSelectedColor(container) {
    const optionInputs = container.querySelectorAll(
      'input[name^="options["], select[name^="options["]'
    );
    let color = null;
    optionInputs.forEach((el) => {
      const labelEl = container.querySelector(`label[for="${el.id}"]`);
      const labelTxt = (labelEl?.textContent || "");
      const nameGuess = el.name.toLowerCase();
      const isColor =
        /color|colore|colour/i.test(labelTxt) || /color|colore|colour/.test(nameGuess);
      if (isColor) {
        color = el.type === "radio" ? (el.checked ? el.value : color) : el.value || color;
      }
    });
    return color;
  }

  function filterMediaForColor(container, color) {
    const gallery = container.querySelector('[data-product-media-thumbnails], [data-thumbnails], .product__media-list, .product__media');
    const main = container.querySelector('[data-product-media], .product__media-wrapper');
    if (!gallery && !main) return;

    const selected = norm(color);
    const mediaEls = container.querySelectorAll('[data-media-id], media-gallery, .product__media-item, [data-product-single-media-wrapper]');

    mediaEls.forEach((el) => {
      const img = el.querySelector('img');
      const alt = (img?.getAttribute('alt') || "").trim();

      const match = /(?:^|\s)color\s*:\s*([^|;,]+)\s*/i.exec(alt);
      if (!match) {
        el.style.display = '';
        return;
      }
      const mediaColor = norm(match[1]);

      // mostra solo se coincide
      if (selected && mediaColor === selected) {
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });

    const anyVisible = Array.from(mediaEls).some((n) => n.style.display !== 'none');
    if (!anyVisible && mediaEls.length) {
      mediaEls[0].style.display = '';
    }
  }

  function attach(container) {
    // re-apply on load
    const initialColor = getSelectedColor(container);
    if (initialColor) filterMediaForColor(container, initialColor);

    container.addEventListener('variant:change', (e) => {
      const color = getSelectedColor(container) || e.detail?.variant?.option1 || e.detail?.color;
      if (color) filterMediaForColor(container, color);
    });

    container.addEventListener('change', (e) => {
      if (e.target?.name?.startsWith('options[')) {
        const color = getSelectedColor(container);
        if (color) filterMediaForColor(container, color);
      }
    });
  }

  // Avvio
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('section[id^="MainProduct-"], .product').forEach(attach);
  });
})();
